<eaglei-leaflet-layer-header [layer]="this" (activeToggled)="toggleLayer($event)" [hideLegend]="true"></eaglei-leaflet-layer-header>

@if (isActive) {
<mat-form-field class="wide">
    <mat-label>Deployment Status</mat-label>
    <mat-select [formControl]="filterControl">
        <mat-option value="all">All</mat-option>
        <mat-option value="deployed">Deployed</mat-option>
        <mat-option value="notDeployed">Not Deployed</mat-option>
    </mat-select>
</mat-form-field>
} @if (isActive) {
<div #legendElement>
    <div class="vertical-legend">
        <div>
            <span class="triangle deployed">&#9650;</span>
            <span>Deployed</span>
        </div>
        <div>
            <span class="triangle not-deployed">&#9650;</span>
            <span>Not Deployed</span>
        </div>
    </div>
</div>
} @if (isActive && canEdit) {
<div class="management-link" (click)="editLocations()">
    <fa-icon icon="external-link-alt"></fa-icon>
    <span>Edit Location Information</span>
</div>
}
